import { useEffect } from 'react';
import { useHistory } from 'umi';
import usePageStore from '@gp/hooks/usePageStore';
import { LOCKER_MODEL_NAMESPACE, DEFAULT_LOCKER_DATA } from '../models/locker';

import type { IStudioPerformanceParams } from '../types/services';
import type { ILockerData } from '../models/locker';

export default function useDomainPageStore(props: {
  getStudioPerformanceParams: () => IStudioPerformanceParams;
  getProjectPerformanceParams: () => IStudioPerformanceParams;
}) {
  const { getStudioPerformanceParams, getProjectPerformanceParams } = props;

  const history = useHistory();

  const { lockerData, setLockerData } = usePageStore<ILockerData>(LOCKER_MODEL_NAMESPACE);

  const { studio: studioInitialData, project: projectInitialData } = lockerData || {};
  const {
    select_studio_id: studioSelectStudioIdInitial,
    yoy: studioYoyInitial,
    mom: studioMomInitial,
    order: studioOrderInitial,
    order_metric: studioOrderMetricInitial,
  } = studioInitialData || {};
  const {
    select_project_id: projectSelectProjectIdInitial,
    select_studio_id: projectSelectStudioIdInitial,
    yoy: projectYoyInitial,
    mom: projectMomInitial,
    order: projectOrderInitial,
    order_metric: projectOrderMetricInitial,
  } = projectInitialData || {};

  /**
   * 监听路由页面切换
   * 1、本页面不做任何处理
   * 2、跳转到studio详情页，需要保留当前的页面状态
   * 3、跳转到其他页面时，需要清除已保存的页面状态
   */
  useEffect(() => {
    const unListen = history.listen((location) => {
      const { pathname } = location || {};
      // 本页面不做任何处理
      if (pathname === '/g-pop/MonthlyReport/PerformanceOverview') return;
      // 跳转到studio详情页，需要保留当前的页面状态
      if (pathname === '/g-pop/Studio/PortfolioOverview/Detail') {
        const studioPerformanceParams = getStudioPerformanceParams();
        const projectPerformanceParams = getProjectPerformanceParams();
        const {
          select_id: studioSelectId,
          yoy: studioYoy,
          mom: studioMom,
          order: studioOrder,
          order_metric: studioOrderMetric,
        } = studioPerformanceParams || {};
        const {
          select_id: projectSelectId,
          select_id_sub: projectSelectStudioId,
          yoy: projectYoy,
          mom: projectMom,
          order: projectOrder,
          order_metric: projectOrderMetric,
        } = projectPerformanceParams || {};
        setLockerData({
          studio: {
            select_studio_id: studioSelectId,
            yoy: studioYoy,
            mom: studioMom,
            order: studioOrder as any,
            order_metric: studioOrderMetric,
          },
          project: {
            select_project_id: projectSelectId,
            select_studio_id: projectSelectStudioId as string[],
            yoy: projectYoy,
            mom: projectMom,
            order: projectOrder as any,
            order_metric: projectOrderMetric,
          },
        });
        return;
      }
      // 否则，需要清除已保存的页面状态
      setLockerData(DEFAULT_LOCKER_DATA);
    });

    // 清理监听器
    return () => {
      unListen();
    };
  }, [history]);

  return {
    studioSelectStudioIdInitial,
    studioYoyInitial,
    studioMomInitial,
    studioOrderInitial,
    studioOrderMetricInitial,

    projectSelectProjectIdInitial,
    projectSelectStudioIdInitial,
    projectYoyInitial,
    projectMomInitial,
    projectOrderInitial,
    projectOrderMetricInitial,
  };
}
